import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Caretaker } from '@shared/models/Caretaker.model';
import { TokenResponse } from '@shared/models/TokenResponse.model';
import { SnackbarService } from '@shared/services/snackbar.service';
import { ApiService } from './api/api.service';
import { AuthApiService } from './api/auth.api.service';

@Injectable({
	providedIn: 'root' // service to work with user, update it etc...
})
export class UserService {

	constructor(
		private snackbar: SnackbarService,
		private api: ApiService,
		private authApi: AuthApiService
	) { }

	public user: Caretaker;
	public user$: BehaviorSubject<Caretaker> = new BehaviorSubject<Caretaker>(null);

	public get userRole(): string {
		return this.user?.role;
	}

	public get userIsSupport(): boolean {
		return this.user?.role === 'ROLE_SUPPORT_USER'
	}

	public setUser(user: Caretaker): void {
		this.user = user;
		this.user$.next(user);
	}

	public getUserObservable(): Observable<Caretaker> {
		return this.api.getCaretaker();
	}

	public isLoggedIn(): boolean {
		return !!this.user;
	}

	public updateUser(caretaker: Partial<Caretaker>): Observable<void> {
		return this.api.updateCaretaker(caretaker).pipe(
			switchMap((caretaker: Caretaker) => {
				this.setUser(caretaker);
				return this.authApi.refresh(localStorage.getItem('refresh_token'));
			}),
			map((token: TokenResponse) => {
				this.snackbar.success('Updated!');
				localStorage.setItem('access_token', token.access_token);
				localStorage.setItem('refresh_token', token.refresh_token);
				localStorage.setItem('expire', (new Date().getTime() + token.expires_in * 1000).toString());
			}),
			catchError((error: HttpErrorResponse) => {
				this.snackbar.error();
				return throwError(error)
			})
		);
	}

	public changePassword(password: string): Observable<void> {
		return this.api.updateCaretaker({ password }).pipe(
			map(() => this.snackbar.success('Password successfully changed')),
			catchError((error: HttpErrorResponse) => {
				this.snackbar.error();
				return throwError(error);
			})
		)
	}

}
